import React from "react";
import { Popover } from "@mui/material";

import ChevronBigDown from "@tiny/icons/generated/ChevronBigDown";
import ChevronBigUp from "@tiny/icons/generated/ChevronBigUp";
import useForwardRef from "../hooks/useForwardRef";
import useId from "../hooks/useId";
import Button from "../Button";
import { DropdownButtonProps } from "./DropdownButton.types";
import { useStyles } from "./DropdownButtonStyles";
import {
  anchorOriginDefault,
  transformOriginDefault,
} from "./DropdownButtonHelpers";

function DropdownButton(
  props: DropdownButtonProps,
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  const {
    anchorOrigin = anchorOriginDefault,
    children,
    text,
    onClick,
    transformOrigin = transformOriginDefault,
    buttonClassName,
    filledIcon,
    shouldCloseOnPopoverClick,
    ...other
  } = props;

  const classes = useStyles();
  const buttonRef = useForwardRef(ref);
  const popoverId = useId();
  const [open, setOpen] = React.useState(false);
  const UpIcon = filledIcon ? ChevronBigUp : ChevronBigUp;
  const DownIcon = filledIcon ? ChevronBigDown : ChevronBigDown;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpen((state) => !state);
    onClick?.(event);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePopoverClick = () => {
    if (shouldCloseOnPopoverClick) {
      setOpen(false);
    }
  };

  return (
    <>
      <Button
        {...other}
        ref={buttonRef}
        onClick={handleClick}
        className={buttonClassName}
        endIcon={
          open ? (
            <UpIcon className={classes.arrow} />
          ) : (
            <DownIcon className={classes.arrow} />
          )
        }
      >
        {text}
      </Button>
      <Popover
        id={popoverId}
        open={open}
        anchorEl={buttonRef.current}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        disableScrollLock
        onClick={handlePopoverClick}
      >
        {children}
      </Popover>
    </>
  );
}

export default React.forwardRef(DropdownButton);
